const useDebug = () => {
  const gridDebug = document.querySelector('[data-name="grid-debug"]')

  const handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'G') {
      gridDebug.classList.toggle('hidden')
    }
  }

  window.addEventListener('keydown', handleKeyDown)
}

export default useDebug
